export default __webpack_public_path__ + "static/media/yo_4.338dfb3b.mp3";